import { render } from "./CreateVpnCustomerGateway.vue?vue&type=template&id=78f297cc"
import script from "./CreateVpnCustomerGateway.vue?vue&type=script&lang=js"
export * from "./CreateVpnCustomerGateway.vue?vue&type=script&lang=js"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__